module.exports = __webpack_public_path__ + "static/media/logo-github.b4fde368.svg";